/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Freeze_Confirm_BillingInputs */



/**
* | output |
* | --- |
* | "Billing stops: no period is closed and its un-invoiced reports leave every money surface." |
*
* @param {Partner_Org_Freeze_Confirm_BillingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_freeze_confirm_billing = /** @type {((inputs?: Partner_Org_Freeze_Confirm_BillingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Freeze_Confirm_BillingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Abrechnung stoppt: Es wird kein Zeitraum abgeschlossen und die nicht fakturierten Berichte verschwinden aus allen Abrechnungsansichten.")
	return /** @type {LocalizedString} */ ("Billing stops: no period is closed and its un-invoiced reports leave every money surface.")
});